import type { DataTableColumn } from '@/components/custom/erp';
import type { LoaiTSCDCCDC } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<LoaiTSCDCCDC>[] => [
  {
    field: 'loai_tscc',
    headerName: 'Loại',
    width: 100,
    renderCell: params => {
      const value = params.row.loai_tscc as unknown;
      return value == 1 ? '1. Tài sản' : '2. Công cụ';
    }
  },
  { field: 'ma_lts', headerName: 'Mã loại', width: 150 },
  { field: 'ten_lts', headerName: 'Tên loại', width: 250 },
  {
    field: 'tk_ts',
    headerName: 'Tài khoản TS',
    width: 150,
    renderCell: params => {
      return params.row.tk_ts_data?.code || params.row.tk_ts || '';
    }
  },
  {
    field: 'tk_kh',
    headerName: 'TK khấu hao',
    width: 150,
    renderCell: params => {
      return params.row.tk_kh_data?.code || params.row.tk_kh || '';
    }
  },
  {
    field: 'tk_cp',
    headerName: 'TK chi phí',
    width: 150,
    renderCell: params => {
      return params.row.tk_cp_data?.code || params.row.tk_cp || '';
    }
  },
  {
    field: 'ma_phi',
    headerName: 'Mã phí',
    width: 150,
    renderCell: params => {
      return params.row.ma_phi_data?.ma_phi || params.row.ma_phi || '';
    }
  }
];
